module.exports = __webpack_public_path__ + "media/images/articles/resignation/thumb-3c3e3cf7b3264bd65c05b1da769e63fc.png";